/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Scan_Btn_LabelInputs */

const vi_lot_scan_btn_label = /** @type {(inputs: Lot_Scan_Btn_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét mã lô để thêm`)
};

/**

* @param {Lot_Scan_Btn_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_scan_btn_label = /** @type {((inputs?: Lot_Scan_Btn_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Scan_Btn_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_scan_btn_label(inputs)
});